import React from "react";

const LineIcon = () => (
  <svg className="line-icon" x="0px" y="0px" viewBox="0 0 36 14">
    <g id="line" transform="translate(-854.631 -269.078)">
      <g
        id="Rectangle_53"
        transform="translate(854.631 269.078)"
        fill="none"
        strokeWidth="2"
      >
        <rect width="36" height="14" rx="7" stroke="none" />
        <rect x="1" y="1" width="34" height="12" rx="6" fill="none" />
      </g>
      <g
        id="Ellipse_25"
        transform="translate(858.631 272.078)"
        fill="none"
        strokeWidth="2"
      >
        <circle cx="4" cy="4" r="4" stroke="none" />
        <circle cx="4" cy="4" r="3" fill="none" />
      </g>
      <g
        id="Ellipse_26"
        transform="translate(868.631 272.078)"
        fill="none"
        strokeWidth="2"
      >
        <circle cx="4" cy="4" r="4" stroke="none" />
        <circle cx="4" cy="4" r="3" fill="none" />
      </g>
      <g
        id="Ellipse_27"
        transform="translate(878.631 272.078)"
        fill="none"
        strokeWidth="2"
      >
        <circle cx="4" cy="4" r="4" stroke="none" />
        <circle cx="4" cy="4" r="3" fill="none" />
      </g>
    </g>
  </svg>
);

export default LineIcon;
